








import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component

export default class loader extends Vue {

}
